<template>
  <common-dialog
    ref="dialog"
    :width="60"
    :title="originalData ? 'Update' : 'Create'"
    :save-cb="saveData"
    :reset-inputs="resetData"
  >
    <template v-slot:content>
      <div class="f-r role-container">
        <div class="left f-c" v-if="formData">
          <div class="input-item f-r-hsb">
            <span class="label">Role Name</span>
            <el-input size="small" v-model="formData.name.value" />
          </div>
          <div class="input-item f-r-hsb">
            <span class="label">Description</span>
            <el-input size="small" v-model="formData.description.value" />
          </div>
          <div class="input-item f-r-hsb">
            <span class="label">Status</span>
            <el-select
              size="small"
              v-model="formData.status.value"
              placeholder="Select"
            >
              <el-option
                v-for="item in formData.status.options"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right">
          <el-tree
            ref="tree"
            node-key="id"
            :props="props"
            :load="loadNode"
            lazy
            show-checkbox
          >
          </el-tree>
        </div>
      </div>
    </template>
  </common-dialog>
</template>
<script>
// apis
import { queryResource } from '@/api/resource'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import { ResourceSingle } from '@/core/models/resource'
export default {
  name: 'RoleCreateOrUpdate',
  components: {
    CommonDialog
  },
  props: {
    formInputInit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      formData: null,
      originalData: null,
      saveDataCb: null,
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      }
    }
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        queryResource({ globalRoot: true, size: -1 }).then(res => {
          return resolve(res.records)
        })
      }
      if (node.level > 0) {
        queryResource({ parentIds: [node.data.id], size: -1 }).then(res => {
          return resolve(
            res.records.map(one => ({
              ...one,
              leaf: one.type === ResourceSingle
            }))
          )
        })
      }
    },
    saveData(_, done, error) {
      let selected = this.$refs.tree.getCheckedNodes()
      let parentIds = selected.map(one => one.parentId)
      parentIds = selected
        .filter(one => parentIds.includes(one.id))
        .map(one => one.id)
      selected = selected.filter(one => !parentIds.includes(one.parentId))
      // get form data
      const roleForm = Object.fromEntries(
        Object.values(this.formData).map(one => [one.key, one.value])
      )
      if (this.originalData) {
        roleForm.id = this.originalData.id
      }
      roleForm.resourceIds = selected.map(one => one.id)
      this.saveDataCb(roleForm)
      done()
    },
    open(data, saveCb = null) {
      this.$set(this, 'originalData', data)
      this.resetData()
      this.$refs.dialog.open()
      this.saveDataCb = saveCb
      setTimeout(() => {
        // set tree selected keys
        const nodes = this.originalData?.resources.map(one => one.id) ?? []
        this.$refs.tree.setCheckedKeys(nodes)
      }, 200)
    },
    resetData() {
      const temp = this.formInputInit(this.originalData)
      this.$set(this, 'formData', temp)
    }
  }
}
</script>
<style lang="scss" scoped>
.role-container {
  gap: 10px;
  min-height: 300px;

  .left {
    width: 40%;
  }

  .right {
    width: 60%;
  }
}

.input-item {
  padding: 0 1px;
  margin-bottom: 5px;

  .el-select,
  .el-input,
  .el-textarea,
  .el-input-number {
    width: 50% !important;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
